// extracted by mini-css-extract-plugin
module.exports = {"batchProcHistGrid":"batchProcHist_batchProcHistGrid__2lala","batchProcHistDialog":"batchProcHist_batchProcHistDialog__1rX3a"};